import { render, staticRenderFns } from "./homeParamType.vue?vue&type=template&id=70a56340&scoped=true"
import script from "./homeParamType.vue?vue&type=script&lang=js"
export * from "./homeParamType.vue?vue&type=script&lang=js"
import style0 from "./homeParamType.vue?vue&type=style&index=0&id=70a56340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a56340",
  null
  
)

export default component.exports